var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWinterSports = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Skiing-Snowboard--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Skiing Snowboard Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2 4.46 0.32 5.63a0.76 0.76 0 0 0 -0.19 1 0.76 0.76 0 0 0 1 0.19L2.48 6a0.27 0.27 0 0 1 0.26 0 0.26 0.26 0 0 1 0.13 0.23v1.52a0.75 0.75 0 0 0 1.5 0V6.17a0.25 0.25 0 0 1 0.14 -0.23 0.25 0.25 0 0 1 0.25 0l1.31 0.91a0.75 0.75 0 0 0 0.85 -1.24L5.23 4.46a0.26 0.26 0 0 1 0 -0.42l1.69 -1.17a0.75 0.75 0 0 0 -0.85 -1.24l-1.31 0.91a0.25 0.25 0 0 1 -0.25 0 0.25 0.25 0 0 1 -0.14 -0.23V0.75a0.75 0.75 0 0 0 -1.5 0v1.58a0.26 0.26 0 0 1 -0.13 0.23 0.27 0.27 0 0 1 -0.26 0l-1.3 -0.91a0.76 0.76 0 0 0 -1 0.19 0.76 0.76 0 0 0 0.14 1.03L2 4a0.26 0.26 0 0 1 0 0.42Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.35 10.22a0.26 0.26 0 0 0 -0.28 0l-6.9 6.9a4 4 0 0 0 5.66 5.66l1.38 -1.38a1 1 0 0 0 0.29 -0.71V10.45a0.24 0.24 0 0 0 -0.15 -0.23Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.35 5.22a0.26 0.26 0 0 0 -0.28 0l-2.28 2.33a1 1 0 0 0 -0.29 0.71v10.29a0.24 0.24 0 0 0 0.15 0.23 0.26 0.26 0 0 0 0.28 -0.05l2.28 -2.28a1 1 0 0 0 0.29 -0.71V5.45a0.24 0.24 0 0 0 -0.15 -0.23Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.83 1.17a4 4 0 0 0 -5.66 0l-1.38 1.38a1 1 0 0 0 -0.29 0.71v10.29a0.24 0.24 0 0 0 0.15 0.23 0.26 0.26 0 0 0 0.28 0l6.9 -6.9a4 4 0 0 0 0 -5.71Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWinterSports);
export default ForwardRef;